import axios from 'axios';

import { handleApiSucess, handleApiError, getRequestHeaders } from 'api/util.api';
import { handleRequest } from './util.api';

export const getFormConfigUrl = (cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/assets/form_config`;

export const getDisableFormConfigUrl = (cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/assets/disable_form_config`;

export const getAddUrl = (cId, sId) => `/companies/${cId}/subcompanies/${sId}/assets`;

export const getAssetsUrl = (cId, sId) => `/companies/${cId}/subcompanies/${sId}/assets`;

export const getByIdAssetUrl = (aId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/assets/${aId}`;

export const updateAssetUrl = (aId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/assets/${aId}`;

export const requestUpdateAssetUrl = (aId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/assets/${aId}/request_update`;

export const disableAssetUrl = (aId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/assets/${aId}/disable`;

export const enableAssetUrl = (aId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/assets/${aId}/enable`;

export const getHistoricsUrl = (aId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/assets/${aId}/historics`;

export const acceptHistoricUrl = (hId, aId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/assets/${aId}/historics/${hId}/accept`;

export const rejectHistoricUrl = (hId, aId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/assets/${aId}/historics/${hId}/reject`;

export const getMaintenance = (cId, sId) => `/companies/${cId}/subcompanies/${sId}/assets/mant`;

const service = {
  configure(endpoint = '', auth = {}, defaultHeaders = {}) {
    this.endpoint = endpoint;
    this.auth = auth;
    this.defaultHeaders = defaultHeaders;
    this.getHeaders = getRequestHeaders(this.auth, this.defaultHeaders);

    this.axios = axios.create({
      baseURL: this.endpoint,
      timeout: 30000,
    });

    this.axios.interceptors.request.use((request) => {
      handleRequest(request);
      return request;
    });

    return this;
  },

  add(companyId, subcompanyId, asset) {
    const url = getAddUrl(companyId, subcompanyId);
    return this.axios
      .post(url, asset, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  get(companyId, subcompanyId, filters, limit, page, orderBy, order) {
    const url = getMaintenance(companyId, subcompanyId);
    const params = { ...filters, limit, page, orderBy, order };
    return this.axios
      .get(url, { ...this.getHeaders(), params })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  getById(assetId, companyId, subcompanyId) {
    const url = getByIdAssetUrl(assetId, companyId, subcompanyId);
    return this.axios
      .get(url, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  update(assetId, companyId, subcompanyId, asset) {
    const url = updateAssetUrl(assetId, companyId, subcompanyId);
    return this.axios
      .put(url, asset, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  disable(assetId, companyId, subcompanyId, asset) {
    const url = disableAssetUrl(assetId, companyId, subcompanyId);
    return this.axios
      .put(url, asset, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  enable(assetId, companyId, subcompanyId) {
    const url = enableAssetUrl(assetId, companyId, subcompanyId);
    return this.axios
      .put(url, {}, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  getFormConfig(companyId, subcompanyId) {
    const url = getFormConfigUrl(companyId, subcompanyId);
    return this.axios
      .get(url, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  getDisableFormConfig(companyId, subcompanyId) {
    const url = getDisableFormConfigUrl(companyId, subcompanyId);
    return this.axios
      .get(url, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  getHistorics(assetId, companyId, subcompanyId, filters, limit, page, orderBy, order) {
    const url = getHistoricsUrl(assetId, companyId, subcompanyId);
    const params = { ...filters, limit, page, orderBy, order };
    return this.axios
      .get(url, { ...this.getHeaders(), params })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  acceptHistoric(hId, assetId, companyId, subcompanyId) {
    const url = acceptHistoricUrl(hId, assetId, companyId, subcompanyId);
    return this.axios
      .put(url, {}, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  rejectHistoric(hId, assetId, companyId, subcompanyId) {
    const url = rejectHistoricUrl(hId, assetId, companyId, subcompanyId);
    return this.axios
      .put(url, {}, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  requestUpdate(assetId, companyId, subcompanyId, asset) {
    const url = requestUpdateAssetUrl(assetId, companyId, subcompanyId);
    return this.axios
      .put(url, asset, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },
};

export default service;



// WEBPACK FOOTER //
// src/lib/api/maintenance.api.js